<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For</i></p>
<p class="ded1">Carel Dan Bud Pete Martha</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?43fefb00